<!-- NAV DIRECTORY - Shown on screens > 768px -->
<nav class="navbar navbar-expand-lg navbar-light subnav justify-content-center">
    <ul class="navbar-nav">
        <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/directory/organizations']">{{ 'directory.nav.organizationDirectory' | translate }}</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/directory/members']">{{ 'directory.nav.userDirectory' | translate }}</a>
        </li>
    </ul>
</nav>

<!-- Mobile nav - Shown on screens <= 768px -->
<div class="container my-3">
    <ul class="sm-nav nav-pills nav-justified">
        <li class="sm-nav-item">
            <a
                class="sm-nav-link"
                [ngClass]="{ active: checkActiveTab() === 'members' }"
                (click)="setActiveTab('utilisateurs')"
                [routerLink]="['/directory/members']"
            >
                <span class="d-flex align-items-center justify-content-center">
                    <i class="pi pi-users mr-1"></i>{{ 'directory.nav.userSmallScreen' | translate }}
                </span>
            </a>
        </li>
        <li class="sm-nav-item">
            <a
                class="sm-nav-link"
                [ngClass]="{ active: checkActiveTab() === 'organizations' }"
                (click)="setActiveTab('organisations')"
                [routerLink]="['/directory/organizations']"
            >
                <span class="d-flex align-items-center justify-content-center">
                    <i class="pi pi-building mr-1"></i>{{ 'directory.nav.organizationSmallScreen' | translate }}</span
                >
            </a>
        </li>
        <li class="sm-nav-item">
            <a class="sm-map-link" *ngIf="listView" (click)="updateView('map')">
                <span>{{ 'directory.nav.seeMap' | translate }}</span>
            </a>

            <a class="sm-map-link" *ngIf="mapView" (click)="updateView('list')">
                <span>{{ 'directory.nav.seeList' | translate }}</span>
            </a>
        </li>
    </ul>
</div>
